module.exports = __webpack_public_path__ + "media/images/capture_icon-76480c8b.svg";